module.exports = __webpack_public_path__ + "img/Group 4@2x14.b94a1c26.png";